enum RFIFileType {
  Attachment = "Attachment",
}

export default RFIFileType;
